import React from 'react';
import { OTPublisher, OTSession, OTStreams, OTSubscriber } from 'opentok-react'
import Subscriber from './Subscriber'
import Publisher from './Publisher'

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      connection: 'Connecting',
			audio: true,
			video: true,
			videoSource: 'camera'
    };

    this.sessionEventHandlers = {
      sessionConnected: () => {
        this.setState({ connection: 'Connected' });
      },
      sessionDisconnected: () => {
        this.setState({ connection: 'Disconnected' });
      },
      sessionReconnected: () => {
        this.setState({ connection: 'Reconnected' });
      },
      sessionReconnecting: () => {
        this.setState({ connection: 'Reconnecting' });
      },
    };

    this.publisherEventHandlers = {
      accessDenied: () => {
        console.log('User denied access to media source');
      },
      streamCreated: () => {
        console.log('Publisher stream created');
      },
      streamDestroyed: ({ reason }) => {
        console.log(`Publisher stream destroyed because: ${reason}`);
      },
    };

    this.subscriberEventHandlers = {
      videoEnabled: () => {
        console.log('Subscriber video enabled');
      },
      videoDisabled: () => {
        console.log('Subscriber video disabled');
      },
    };
  }

  onSessionError = error => {
    this.setState({ error });
  };

  onPublish = () => {
    console.log('Publish Success');
  };

  onPublishError = error => {
    this.setState({ error });
  };

  onSubscribe = () => {
    console.log('Subscribe Success');
  };

  onSubscribeError = error => {
    this.setState({ error });
  };

	toggleVideoSource = () => {
		this.setState(state => ({
			videoSource: state.videoSource === 'camera' ? 'screen' : 'camera',
		}));
	};

  toggleVideo = () => {
    this.setState(state => ({
      video: !state.video,
    }));
  };

	toggleAudio = () => {
		this.setState(state => ({
			audio: !state.audio,
		}));
	};

  render() {
    const { apiKey, sessionId, token } = this.props.credentials;
    const { error, connection, video, audio, videoSource } = this.state;
    return (
      <div>
        <div id="sessionStatus" className={'sessionStatus'}>Session Status: {connection}</div>
        {error ? (
          <div className="error">
            <strong>Error:</strong> {error}
          </div>
        ) : null}
        <OTSession
          apiKey={apiKey}
          sessionId={sessionId}
          token={token}
          onError={this.onSessionError}
          eventHandlers={this.sessionEventHandlers}
        >
					<Publisher
						className='streamSharing'
						toggleVideo={this.toggleVideo}
						toggleAudio={this.toggleAudio}
						toggleVideoSource={this.toggleVideoSource}
						video={video} 
						audio={audio}
						videoSource={videoSource}
						properties={{
							publishVideo: video,
							publishAudio: audio,
							width: 150, height: 150,
						}}
						onPublish={this.onPublish}
						onError={this.onPublishError}
						eventHandlers={this.publisherEventHandlers}
					/>
					<div/>
          <OTStreams>
            <Subscriber
              onSubscribe={this.onSubscribe}
              onError={this.onSubscribeError}
              eventHandlers={this.subscriberEventHandlers}
            />
          </OTStreams>
        </OTSession>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js